module.exports = __webpack_public_path__ + "static/media/LOGOUT_RED.1bc65759.svg";